import React, { useEffect } from 'react'
import classes from './SubmitButton.module.css'

import { useDispatch, useSelector } from 'react-redux'
import { formActions } from '../../store/form-slice'

const SubmitButton = () => {
  const dispatch = useDispatch()

  const formIsValid = useSelector((state) => state.form.formIsValid)

  useEffect(() => {
    if (formIsValid) {
      dispatch(formActions.setSubmitForm())
    }
  }, [formIsValid, dispatch])

  const checkRatesClickHandler = () => {
    if (!formIsValid) {
      dispatch(formActions.setFormIsValid())
    }
  }

  return (
    <div className={classes.searchButtonContainer}>
      <button className={classes.searchButton} onClick={checkRatesClickHandler}>
        Submit My Request!
      </button>
    </div>
  )
}

export default SubmitButton
